module.exports = __webpack_public_path__ + "static/media/video-placeholder.a622fc5d.jpg";